import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          开始您的膀胱健康之旅
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-6 md:mb-8 max-w-[500px] mx-auto leading-relaxed">
          科学的知识配合正确的训练，每个人都能拥有更健康的生活。现在就开始学习吧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/training-methods"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary-600 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            探索训练方法
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 text-white rounded-full text-sm font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-white/25"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}